import { render } from "./dropGoods.vue?vue&type=template&id=6d423650&scoped=true"
import script from "./dropGoods.vue?vue&type=script&lang=js"
export * from "./dropGoods.vue?vue&type=script&lang=js"

import "./dropGoods.vue?vue&type=style&index=0&id=6d423650&scoped=true&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d423650"]])

export default __exports__